import PicturesApp from 'station/components/picture/PicturesApp'
import React, { useMemo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import useTitle from 'utils/customHook/useTitle'
import i18n from 'simple-react-i18n'
import { getStationTitleWithTownName } from 'utils/StationUtils'

const PluviometryPicturesApp = ({

}) => {
    const {
        pluviometer,
        pluviometers,
        citiesIndex,
    } = useSelector(store => ({
        pluviometer: store.PluviometryReducer.pluviometer,
        pluviometers: store.PluviometryReducer.pluviometers,
        citiesIndex: store.CityReducer.citiesIndex,
    }), shallowEqual)

    const townName = useMemo(() => citiesIndex[pluviometer.townCode]?.name, [citiesIndex, pluviometer])

    useTitle(() => [{
        title: i18n.pluviometry,
        href: 'pluviometry',
    }, {
        title: getStationTitleWithTownName(pluviometer, townName),
        href: `station/pluviometry/${pluviometer?.id}`,
    }, {
        title: i18n.picturesAndDocuments,
        href: `station/pluviometry/${pluviometer?.id}/picture`,
    }], [pluviometer, townName])

    return (
        <PicturesApp
            stations={pluviometers}
            station={pluviometer}
            stationType='pluviometry'
        />
    )
}

export default PluviometryPicturesApp